export * from './useSiteListQuery';

export interface ISiteListResponse {
	id: number;
	sfid: string;
	name: string;
	site_location_c: string;
	latitude: number;
	longitude: number;
	pincode_c?: string | null;
	address_c: string | null;
	end_user_phone_c: string | null;
	end_user_name_c: string | null;
	applicatorname_c: string | null;
	applicator_phone_number_text_c: string | null;
	site_sub_type_c: string;
	solvent_used_c: string | null;
	fevicol_business_potential_c: string | null;
	epoxy_adhesive_used_c: string | null;
	competition_brand_c: string | null;
	lastactivitydate: string;
	last_updated_on_tsi_cmdi_asi_c: string | null;
	next_scheduled_visit_date: string | null;
	whom_did_you_meet_c: string;
	site_current_status_c: string;
	convert_status: boolean;
	priority: number;
	is_fcc_contactor: boolean;
	site_priority?: number;
	source?: string | null;
	current_stage_of_site_c?: string | null;
	reason_sitelose_lost_competition_c?: string | null;
	createddate?: string;
	glue_consumed_as_of_last_visit_date?: string | null;
	conversion_volume?: string | null;
	brand_converted?: string | null;
	date_of_next_visit?: string | null;
	glueconsumedtilldate_c?: string | null;
	date_of_visit?: string | null;
	adopted_site?: boolean;
	membership_no?: string | null;
	lead_membership_no?: string | null;
	lead_status?: string | null;
	non_end_category_c?: string | null;
}

export interface ISiteListRxDb {
	result: { _data: ISiteListResponse }[];
	isFetching: boolean;
	fetchMore: () => void;
	totalCount: number;
}

export const SiteListFieldMap: Record<string, string> = {
	Competition: 'solvent_used_c',
	Upcoming: 'site_current_status_c',
};

export interface ISiteVisit {
	id: number;
	activitydatetime: string;
	activitydate: string;
	subject: string;
	site_visit_status: string;
	sfid: string;
	app_id: string;
	verification_status_c: string;
	end_user_site_r_app_id_c: string;
	end_user_site_c: string;
	site_name_c: string;
	whom_did_you_meet_c: string;
	glue_used_at_the_site: string;
	grade_glue_used_at_the_site: string;
	brand_available_at_site: string;
	glue_potential_in_kg: string;
	reason_of_competition: string;
	conversion_potential_in_kg: string;
	substrate_available: string;
	glue_used_so_far: string;
	event_image_c: string | null;
	event_image1_c: string | null;
	event_image2_c: string | null;
	event_image4_c: string | null;
	event_image5_c: string | null;
}

export interface ISiteDetail {
	id: number;
	sfid: string;
	name: string;
	site_location_c: string;
	latitude: number;
	longitude: number;
	address_c: string;
	end_user_phone_c: string | null;
	applicator_phone_number_text_c: string;
	site_sub_type_c: string;
	solvent_used_c: string;
	fevicol_business_potential_c: string;
	epoxy_adhesive_used_c: string;
	competition_brand_c: string;
	lastactivitydate: string;
	whom_did_you_meet_c: string;
	site_current_status_c: string;
	site_priority: number;
	visits: ISiteVisit[];
}

export interface ISiteDetailResponse {
	message: string;
	data: ISiteDetail[];
}
